import {ExpenseTypeDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createExpenseType(
    userData: Record<string, string>,
    expenseType: Record<string, any>
) {
    try {
        const result = await ExpenseTypeDao.createExpenseType(userData.userToken, expenseType);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
